import { defineComponent, computed } from "vue";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "heading",
  props: {
    align: { default: void 0 },
    size: { default: "" },
    theme: { default: void 0 },
    tag: { default: "h1" },
    fontWeight: { default: "bold" },
    text: { default: "" },
    textUppercase: { type: Boolean, default: false },
    spacesTop: { type: Boolean, default: false },
    spacesBottom: { type: Boolean, default: false },
    spacesTopRem: { type: Boolean, default: false },
    spacesBottomRem: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const placeholderHeadingSizes = {
      xxl: "h1",
      xl: "h2",
      lg: "h3",
      md: "h4",
      sm: "h5",
      xs: "h6"
    };
    const classes = computed(() => {
      const modifier = [];
      if (props.spacesTop)
        modifier.push("heading--spaces-top");
      if (props.spacesBottom)
        modifier.push("heading--spaces-bottom");
      if (props.spacesTopRem)
        modifier.push("heading--spaces-top-rem");
      if (props.spacesBottomRem)
        modifier.push("heading--spaces-bottom-rem");
      if (props.theme)
        modifier.push(`text--${props.theme}`);
      if (props.align)
        modifier.push(`text--${props.align}`);
      modifier.push(`text--${props.size ? placeholderHeadingSizes[props.size] : props.tag}`);
      if (props.fontWeight)
        modifier.push(`text--${props.fontWeight}`);
      if (props.textUppercase)
        modifier.push("text--uppercase");
      return modifier;
    });
    return { __sfc: true, props, placeholderHeadingSizes, classes };
  }
});
export {
  _sfc_main as default
};
